// 维持一些pc/h5公共的常量定义

/**
 * LazyImage组件 randomColors
 */
export const LazyImageRandomColors = ['#C6C0BC', '#BCBFC6', '#C0BCC6', '#C6BCBC', '#C6C6BC', '#BCC5C6']
